    <template>
    <b-overlay :show="showoverlay" rounded="sm">
        <div>
            <div class="atlhr-pf-wizard">

                <div class="row">
                    <div class="col-md-3 custom-sidebar py-5">
                        <h4 class="side-navbar-title mb-4">PF Processing</h4>
                        <div class="panel-group side-navbar" v-if="site_settings_loaded">
                            <a href="#" target="_self" class="nav-link" :class="{ active: ewtabIndex == 0 }" @click.stop="open_item_selected(0)">Dashboard</a>

                            <a href="#" target="_self" class="nav-link" :class="{ active: ewtabIndex == 1 }" @click.stop="open_item_selected(1)">Employee Signup</a>

                            <!-- <a href="#" target="_self" class="nav-link" :class="{ active: ewtabIndex == 2 }" @click.stop="open_item_selected(2)" v-if="site_setting['investment_feature'] == '0'" >Distribution</a> -->
                            <a href="#" target="_self" class="nav-link" :class="{ active: ewtabIndex == 2 }" @click.stop="open_item_selected(2)" v-if="!addons.includes('PfInvestment')">Distribution</a>

                            <a href="#" target="_self" class="nav-link" :class="{ active: ewtabIndex == 3 }" @click.stop="open_item_selected(3)">PF Advance Management</a>

                            <div class="panel panel-default">
                                <div class="panel-heading">
                                    <h4 class="panel-title mb-0">
                                        <a :class="{ 'collapsed' : ewtabIndex != 4 && ewtabIndex != 5 }" data-toggle="collapse" href="#collapse5">De-Registration from PF</a><!-- Mustafijur: 24-08-2026 -->
                                    </h4>
                                </div>
                                <div id="collapse5" class="panel-collapse collapse" :class="{ 'show' : ewtabIndex == 4 || ewtabIndex == 5 }"><!-- Mustafijur: 24-08-2026 -->
                                    <ul class="list-group">
                                        <li class="list-group-item nav-item"><a href="#" class="dropdown-item" :class="{ active : ewtabIndex == 4 }" @click.stop="open_item_selected(4)">De-Registration</a></li><!-- Mustafijur: 24-08-2026 -->
                                        <li class="list-group-item nav-item"><a href="#" class="dropdown-item" :class="{ active : ewtabIndex == 5 }" @click.stop="open_item_selected(5)">Settlements</a></li><!-- Mustafijur: 24-08-2026 -->
                                    </ul>
                                </div>
                            </div>

                            <a v-if="site_setting && site_setting['pf_profit_waive_feature'] == 1" href="#" target="_self" class="nav-link" :class="{ active: ewtabIndex == 6 }" @click.stop="open_item_selected(6)">Waived Profit</a>
                        </div>
                    </div>
                    <div class="col-md-9 pr-0">
                        <b-alert show dismissible fade v-if='successmsg'>{{ successmsg }}</b-alert>
                        <b-alert show dismissible fade v-if='warningmsg' variant='warning'>{{ warningmsg }}</b-alert>
                        <b-alert show dismissible fade v-if='dangermsg' variant='danger'>{{ dangermsg }}</b-alert>
                        <!-- <div class="row no-gutters py-2 mb-3 pl-3">
                            <div class="col-md-10 col-sm-12">
                                <h4 class="atlhr-dashboard-title mt-10 mb-0">
                                    Provident Fund Processing <span class="black-title"></span>
                                    <span>
                                        <a v-bind:href="pageurl">Dashboard</a>
                                        / Provident Fund Processing
                                    </span>
                                </h4>
                            </div>
                        </div> -->
                        <div class="regulatory-filing-tab payroll-reporting-tab col-md-12" id="nav-tabContent-intro">

                            <b-tabs v-model="ewtabIndex" pills content-class="" nav-class="justify-content-left pr-2 m-2"
                                nav-wrapper-class="col-md-9 custom-margin custom-tab-nav pl-0 d-none">
                                <template v-if="ce">
                                    <b-tab lazy>
                                        <h4 class="atlhr-dashboard-title mt-10 mb-4">
                                            Provident Fund Processing <span class="black-title"></span>
                                            <span>
                                                <a v-bind:href="pageurl">Dashboard</a>
                                                / Provident Fund Processing
                                            </span>
                                        </h4>
                                        <template active v-slot:title>Dashboard</template>
                                        <div class="ibox col-md-12 border-0">
                                            <div
                                                class="ibox-title dashboard_title company-form-box-title pf-contribution pl-0">

                                            </div>
                                            <div class="clearfix">
                                                <div class="">
                                                    <pf-dashboard></pf-dashboard>
                                                </div>
                                            </div>

                                        </div>
                                        <pf-dashboard-summary></pf-dashboard-summary>
                                    </b-tab>
                                    <b-tab lazy>

                                        <h4 class="atlhr-dashboard-title mt-10 mb-4">
                                            Provident Fund Processing <span class="black-title"></span>
                                            <span>
                                                <a v-bind:href="pageurl">Dashboard</a>
                                                / Provident Fund Processing / Employee Signup
                                            </span>
                                        </h4>
                                        <div class="ibox col-md-12 border-0">
                                            <div
                                                class="ibox-title dashboard_title company-form-box-title pf-contribution pl-0">
                                                <h4 class="clearfix">
                                                    <span class="float-left">Employee Signup
                                                        <span class="title-sub-text">Employee provident fund registration and process pf applications.
                                                        </span>
                                                    </span>
                                                    <span class="float-right">
                                                    </span>
                                                </h4>
                                            </div>
                                            <div class="clearfix pb-3">
                                                <div class="">
                                                    <pfsignup :pageurl="this.$api_url" :flg="c_flg"
                                                        v-on:childToParent="getAccountEmployees"></pfsignup>
                                                </div>
                                            </div>
                                        </div>



                                    </b-tab>

                                    <b-tab lazy >
                                        <h4 class="atlhr-dashboard-title mt-10 mb-4">
                                            Provident Fund Processing <span class="black-title"></span>
                                            <span>
                                                <a v-bind:href="pageurl">Dashboard</a>
                                                / Provident Fund Processing / Distribution
                                            </span>
                                        </h4>

                                        <div class="ibox col-md-12 border-0">
                                            <div
                                                class="ibox-title dashboard_title company-form-box-title pf-contribution pl-0">
                                                <h4 class="clearfix">
                                                    <span class="float-left">Distribution
                                                        <span class="title-sub-text">Distribute Company profit,forfeiture fund.Process forfeiture reclaims.
                                                        </span>
                                                    </span>
                                                    <span class="float-right"></span>
                                                </h4>
                                            </div>
                                            <div class="clearfix">
                                                <div class="">
                                                    <pf-distribution :pageurl="this.$api_url" :flg="c_flg"></pf-distribution>
                                                </div>
                                            </div>
                                        </div>
                                    </b-tab>


                                    <b-tab lazy>
                                        <template active v-slot:title>PF Advance Management</template>

                                        <h4 class="atlhr-dashboard-title mt-10 mb-4">
                                            Provident Fund Processing <span class="black-title"></span>
                                            <span>
                                                <a v-bind:href="pageurl">Dashboard</a>
                                                / Provident Fund Processing / PF Advance Management
                                            </span>
                                        </h4>
                                        <div class="ibox col-md-12 border-0">
                                            <div
                                                class="ibox-title dashboard_title company-form-box-title pf-contribution pl-0">
                                                <h4 class="clearfix">
                                                    <!-- Start: Rejwan: 27-04-2025 spelling correction -->
                                                    <!-- <span class="float-left">Provident Fund Loan Management -->
                                                        <!-- <span class="title-sub-text">Distribute PF loans. Process loan applications.
                                                        </span> -->
                                                    <!-- </span> -->
                                                    <span class="float-left">Provident Fund Advance Management

                                                    </span>
                                                    <!-- End: Rejwan: 27-04-2025 spelling correction -->
                                                    <span class="float-right">
                                                    </span>
                                                </h4>
                                                <p style="padding-bottom: 30px;">
                                                    <span class="title-sub-text">Distribute PF advances. Process advance applications.</span>
                                                </p>
                                            </div>
                                            <div class="clearfix">
                                                <div class="">
                                                    <pf-loan :pageurl="this.$api_url" :flg="c_flg"></pf-loan>
                                                </div>
                                            </div>
                                        </div>

                                    </b-tab>




                                    <b-tab lazy>
                                        <template active v-slot:title>De-Registration</template>

                                        <h4 class="atlhr-dashboard-title mt-10 mb-4">
                                            Provident Fund Processing <span class="black-title"></span>
                                            <span>
                                                <a v-bind:href="pageurl">Dashboard</a>
                                                / Provident Fund Processing / De-Registration from PF / De-Registration
                                            </span>
                                        </h4>
                                        <div class="ibox col-md-12 border-0">
                                            <div
                                                class="ibox-title dashboard_title company-form-box-title pf-contribution pl-0">
                                                <h4 class="clearfix">
                                                    <span class="float-left">De-Registration from Provident Fund

                                                    </span>
                                                    <span class="float-right">
                                                    </span>
                                                </h4>
                                                <p style="padding-bottom: 30px;">
                                                    <span class="title-sub-text">Deregister employees from
                                                        provident fund.Process deregistration applications.
                                                    </span>
                                                </p>
                                            </div>
                                            <div class="clearfix">
                                                <div class="">
                                                    <pf-de-registration :pageurl="this.$api_url" :flg="c_flg"
                                                    v-on:childToParent="getAccountEmployees"></pf-de-registration>
                                                </div>
                                            </div>
                                        </div>

                                    </b-tab>

                                    <b-tab lazy>
                                        <template active v-slot:title>Settlements</template>

                                        <h4 class="atlhr-dashboard-title mt-10 mb-4">
                                            Provident Fund Processing <span class="black-title"></span>
                                            <span>
                                                <a v-bind:href="pageurl">Dashboard</a>
                                                / Provident Fund Processing / De-Registration from PF / Settlements
                                            </span>
                                        </h4>
                                        <div class=" ibox col-md-12 border-0">
                                            <div
                                                class="ibox-title dashboard_title company-form-box-title pf-contribution pl-0">
                                                <h4 class="clearfix">
                                                    <span class="float-left">Settlements for Former Members of PF

                                                    </span>
                                                    <span class="float-right">
                                                    </span>
                                                </h4>
                                                 <p style="padding-bottom: 30px;">
                                                    <span class="title-sub-text">Settlement processing for Former Members of Provident Fund, including starting from creating settlement applications, going through approvals, and disbursing to bank.
                                                        </span>
                                                 </p>
                                            </div>
                                            <div class="clearfix">
                                                <div class="">
                                                    <pf-settlement-dashboard :pageurl="this.$api_url" :flg="c_flg"
                                                    v-on:childToParent="getAccountEmployees"></pf-settlement-dashboard>
                                                </div>
                                            </div>
                                        </div>
                                    </b-tab>

                                    <!-- Start: Rejwan: 29-01-2025 -->
                                    <b-tab lazy>
                                        <template active v-slot:title>Waived Profit</template>

                                        <h4 class="atlhr-dashboard-title mt-10 mb-4">
                                            Provident Fund Processing <span class="black-title"></span>
                                            <span>
                                                <a v-bind:href="pageurl">Dashboard</a>
                                                / Provident Fund Processing / Waived Profit
                                            </span>
                                        </h4>
                                        <div class="ibox col-md-12 border-0">
                                            <div class="ibox-title dashboard_title company-form-box-title pf-contribution pl-0">
                                                <h4 class="clearfix">
                                                    <span class="float-left">

                                                    </span>
                                                    <span class="float-right">
                                                    </span>
                                                </h4>
                                                <p style="padding-bottom: 30px;">
                                                    <span class="title-sub-text"></span>
                                                </p>
                                            </div>
                                            <div class="clearfix pb-3">
                                                <div class="">
                                                    <pf-waiver-list :pageurl="this.$api_url" :flg="c_flg"></pf-waiver-list>
                                                </div>
                                            </div>
                                        </div>

                                    </b-tab>
                                    <!-- End: Rejwan: 29-01-2025 -->
                                </template>

                            </b-tabs>
                        </div>
                    </div>
                </div>



                <b-modal id="bv-modal-employeesearch" size="lg" hide-footer title="Search Employees">
                    <keep-alive>
                        <SearchEmployees :pageurl="this.$api_url"></SearchEmployees>
                    </keep-alive>
                </b-modal>
            </div>
        </div>
    </b-overlay>
</template>
<script>
import PfDashboard from './PfDashboard.vue';

export default {
    mounted() {
        this.setTabIndex();
        //this.showoverlay = false;
        //setTimeout(this.showContent , 3000);
    },
    props: ['readonly', 'pageurl'],
    components: {
        PfDashboard
        },
    data() {

        return {
            showoverlay: false,
            cu: window.location.href,
            ce: false,
            company_name: '',
            avatarsrc: null,
            employee_id: 0,
            company_id: 0,
            ewtabIndex: 0,
            tabIndex: 0,
            employee_exists: 'employee-exists',
            public_info: [{ name: '', email: '', jobposition: '', department: '', company: '', join_date: '', contract_expire: '' }],
            pageUrl: this.$api_url,
            pgeUrl: this.$api_url,
            isHovered: false,
            successmsg: false,
            warningmsg: false,
            dangermsg: false,
            c_flg: 0, // This variable is for reloading public info
            site_setting: {
                // investment_feature: 0,
                pf_profit_waive_feature: 0,
            },
            site_settings_loaded: false,
            addons: [],
        }
    },
    methods: {
        // barsha
        open_item_selected: function (item) {
            this.ewtabIndex = item;
        },

        // barsha

        showContent: function () {
            this.showoverlay = false;
        },
        getAcl: function () {
            axios.get(this.$api_url + '/acl', {
                params: {
                    url: this.cu
                }
            }).then(function (response) {
                this.ce = response.data;
                if (this.ce == false) this.ewtabIndex = 0;

            }.bind(this));
        },
        showSerch: function () {
            this.$bvModal.show('bv-modal-employeesearch');
        },
        getEmployeeData: function () {
            if (!this.checkNet()) return false;

            this.c_flg += 1;
            //alert('hi');
            /*axios.get('/employee/publicinfo')
                .then(function (response) {

                    this.public_info = response.data;
                    this.company_id = this.public_info.company_id;
                    this.employee_id = this.public_info.employee_id;

                    this.avatarsrc ='/images/employee/'+ this.company_id + '/' + this.public_info.pic;

                }.bind(this));*/
        },
        // Start: Rejwan: 03-06-2025 2 decimal
        // formatMoney: function (amount) {
        //     var money = Number(amount);

        //     if (this.$atl_company_number_format == 'no') {
        //         money = Math.round(money);
        //         money = money.toLocaleString();
        //     }
        //     else {
        //         money = money.toLocaleString();
        //         if (money == 'NaN')
        //             money = amount;
        //         else {
        //             if (money.indexOf(".") < 0)
        //                 money = money + ".00";
        //         }

        //     }

        //     return money;
        // },
        // End: Rejwan: 03-06-2025 2 decimal
        handleHover(hovered) {

            this.isHovered = hovered
        },
        getAccountEmployees(value) {
            this.employee_id = value.employee_id;
            if (this.employee_id > 0) {
                this.getEmployeeData();
            }

        },
        getContractForm(value) {
            this.public_info.contract_expire = value.contract_expire;
        },
        getPFReportHeaderInfo: function () {
            axios.get(this.$api_url + '/pf/report/header')
                .then(function (response) {
                    this.company_name = response.data.company_name;


                }.bind(this));

        },
        setTabIndex: function (event) {
            if (!this.checkNet()) return false;
            axios.get(this.$api_url + '/employee/getid')
                .then(function (response) {

                    if (this.ce == false) {
                        this.ewtabIndex = 0;
                        return;
                    }

                    this.employee_id = response.data;

                    let uri = window.location.href.split('?');
                    if (uri.length == 2) {
                        let vars = uri[1].split('&');
                        let getVars = {};
                        let tmp = '';
                        vars.forEach(function (v) {
                            tmp = v.split('=');
                            if (tmp.length == 2)
                                getVars[tmp[0]] = tmp[1];
                        });
                        //console.log(getVars['#']);
                        if (getVars['#'])
                            this.ewtabIndex = parseInt(getVars['#']);

                    }


                }.bind(this));

        },
        loadPfSiteOptions() {
            axios.get(this.$api_url + '/load-site-options').then(response => {
                response.data.forEach(o => {
                    // if (['investment_feature', 'pf_profit_waive_feature'].includes(o.opt_key)) {
                    if (['pf_profit_waive_feature'].includes(o.opt_key)) {
                        this.site_setting[o.opt_key] = o.opt_value;
                    }
                });
                // this.site_settings_loaded = true; 
            });
        },
        getCompanyData() {
            if (!this.checkNet()) return false;
            axios.get(this.$api_url + '/company/details').then(response => {
                if (response.data.length != 0) {
                    this.addons  = response.data.module_disabled;
                }
                this.site_settings_loaded = true;
            });
        },
    },
    created: function () {
        this.getAcl();
        this.getPFReportHeaderInfo();
        this.loadPfSiteOptions();
        this.getCompanyData();
    }

}

</script>


<style>
.atlhr-pf-wizard .reports-tab-nav-wrapper .nav-item .nav-link .btn-secondary {
    position: absolute;
    bottom: 10px !important;
}

.atlhr-pf-wizard .reports-tab-nav-wrapper .nav-item .nav-link {
    height: 160px !important;
    position: relative;
}</style>
